import React, {useContext} from 'react';
import GenericDialog from '@common/GenericDialog';
import {
    Add,
    ArrowDownwardRounded,
    DeleteRounded,
    ExpandMoreRounded,
    ArrowUpwardRounded,
    Reorder, CloseRounded
} from "@mui/icons-material";
import {BrandContext} from "@context/BrandContext";
import Button from "@common/Button";

const TestHelpDialog = ({
                               open,
                               onClose,
                               isDiagnostic,
                               isExam
                           }) => {
    const brandConfig = useContext(BrandContext),
        testTypeDisplayName = isDiagnostic ? brandConfig.diagnosticName : brandConfig.testName;

    return (
        <GenericDialog
            title={testTypeDisplayName + ' Help'}
            open={open}
            dialogWidth={720}
            // fullWidth={true}
            onClose={onClose}
            buttons={[
                { name: 'Close' },
            ]}
        >
            <div className={'padding--m'}>
                <ul id={'testHelpList'}>
                    <li>
                        <p>Your {testTypeDisplayName} will display in the 'Selected Questions' section.</p>
                    </li>
                    <li>
                        <p>To search questions for your {testTypeDisplayName} select the {brandConfig.topicsName}/{brandConfig.conceptsName} you want below.</p>
                    </li>
                    <li>
                        <p>Questions can be fully viewed by pressing <span style={{verticalAlign:'middle'}}><ExpandMoreRounded sx={{ color: 'var(--secondary-colour)' }} ariaLabel="expand question button" /></span> and added to your {testTypeDisplayName} by pressing <span style={{verticalAlign:'middle'}}><Add ariaLabel={'add question button'} sx={{ color: 'var(--secondary-colour)' }} /></span> on the question.</p>
                    </li>
                    <li>
                        <p>Questions can be rearranged in the Reorder View by pressing <span style={{verticalAlign:'middle'}}><Reorder sx={{ color: 'var(--secondary-colour)' }} /></span> or by pressing the <span style={{verticalAlign:'middle'}}><ArrowUpwardRounded sx={{ color: 'var(--secondary-colour)' }} /></span><span style={{verticalAlign:'middle'}}><ArrowDownwardRounded sx={{ color: 'var(--secondary-colour)' }} /></span> buttons.</p>
                    </li>
                    <li>
                        <p>Questions can be deleted from 'Selected Questions' by using the checkboxes and pressing <span style={{verticalAlign:'middle'}}><DeleteRounded ariaLabel="delete question button" sx={{ color: 'var(--secondary-colour)' }} /></span> or by pressing the <span style={{verticalAlign:'middle'}}><CloseRounded sx={{ color: 'var(--secondary-colour)' }} /></span> for that question.</p>
                    </li>
                    <li>
                        <p>Make sure to save your {testTypeDisplayName} after any changes.</p>
                    </li>
                    {(brandConfig.testOnlyQuestions && !isExam || true) && (
                        <li>
                            <p>
                                Questions with a <div style={{display:'inline-block'}} className="nonDigitalOnlyLegend"></div> background also appear in the Chapter Tests (which are in the 'Teacher Resources' icon on the dashboard), so students may have seen them before.
                            </p>
                        </li>
                    )}
                </ul>
            </div>
        </GenericDialog>
    );
};

export default TestHelpDialog;
